import { Box, Text } from '@nimbus-ds/components';

function RecurrentPaymentDataSkeleton() {
  return (
    <Box
      display="flex"
      gap="2"
      flexDirection="row"
      justifyContent="space-between"
      padding="4"
    >
      <Box display="flex" flexDirection="column" flex="1 1 95%" gap="1-5">
        <Text.Skeleton width="50%" />
        <Text.Skeleton width="20%" />
      </Box>
      <Box display="flex" flexDirection="column" flex="1 1 5%">
        <Text.Skeleton />
      </Box>
    </Box>
  );
}

export default RecurrentPaymentDataSkeleton;
